import {Component, inject, input, OnInit, signal} from "@angular/core";
import {UntilDestroy, untilDestroyed} from "@ngneat/until-destroy";
import {SimWindowService} from "@services";

@UntilDestroy()
@Component({
	selector: "sim-component-loading-container",
	templateUrl: "./component-loading-container.component.html",
	styleUrls: ["./component-loading-container.component.scss"],
	standalone: true,
})
export class ComponentLoadingContainerComponent implements OnInit {
	// Inputs
	public errorLoading = input<boolean>(false);
	public topLevel = input<boolean>(false);
	public loadingMessage = input<string>("");
	public loadingDescriptionMessage = input<string>("");
	public fullWidthLoadingCon = input<boolean>(false);
	public loadingIcon = input<string>("");
	public errorMessage = input<string>("");
	public isLoading = input<boolean>(false);
	public showBackDrop = input<boolean>(false);
	public size = input<"normal" | "big">("normal");
	public backdropVariantTwo = input<boolean>(false);

	// Properties
	public isTwoScreen = signal<boolean>(false);

	// Injections
	private _simWindowService = inject(SimWindowService);

	public ngOnInit(): void {
		this._simWindowService.isTwoScreen.pipe(untilDestroyed(this)).subscribe(this.isTwoScreen.set);
	}
}
